/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
class ScrollingBanner extends HTMLElement {
  constructor() {
    super();
    this.duplicatedLinks = null;
    this.isMobile = false;
    this.isDragging = false;
    this.startX = 0;
    this.currentX = 0;
    this.scrollOffset = 0;
    this.animationFrame = null;
    this.autoScrollSpeed = 0;
    this.bannerWidth = 0;
    this.firstBanner = null;
    this.animationDirection = 1;
    this.touchActive = false;
    this.swipeStarted = false;
    this.startY = 0;
    this.touchEndProcessed = false;
  }

  connectedCallback() {
    this.init();
    this.checkMobile();
    this.setupMobileSwipe();
    window.addEventListener('resize', () => this.checkMobile());
  }

  disconnectedCallback() {
    this.cleanup();
    window.removeEventListener('resize', () => this.checkMobile());
  }

  checkMobile() {
    const wasMobile = this.isMobile;
    this.isMobile = window.innerWidth <= 767;
    
    
    if (wasMobile !== this.isMobile && this.firstBanner) {
      this.setupMobileSwipe();
    }
  }

  init() {
    this.duplicatedLinks = this.querySelectorAll('ol[data-duplicated] a');
    this.duplicatedLinks.forEach(link => {
      link.setAttribute('tabindex', '-1');
    });
    
    this.firstBanner = this.querySelector('.banner');
    // For right-to-left scrolling (normal), we need negative speed
    // For left-to-right scrolling (reverse), we need positive speed
    this.animationDirection = this.classList.contains('animation-direction-reverse') ? 1 : -1;
    
    if (this.firstBanner) {
      this.updateDimensions();
    }
  }

  updateDimensions() {
    if (!this.firstBanner) return;
    
    void this.firstBanner.offsetWidth; // Force reflow
    
    this.bannerWidth = this.firstBanner.offsetWidth;
    
    const animationSpeed = getComputedStyle(this).getPropertyValue('--scrolling-banner-animation-speed');
    if (animationSpeed) {
      const speedValue = parseFloat(animationSpeed);
      if (speedValue > 0 && this.bannerWidth > 0) {
        this.autoScrollSpeed = (this.bannerWidth / (speedValue * 60)) * this.animationDirection;
      } else {
        this.autoScrollSpeed = 0;
      }
    } else {
      this.autoScrollSpeed = this.bannerWidth > 0 ? (this.bannerWidth / (60 * 60)) * this.animationDirection : 0;
    }
    
    
  }

  setupMobileSwipe() {
    
    
    if (!this.isMobile) {
      const banners = this.querySelectorAll('.banner');
      banners.forEach(banner => {
        banner.style.animationPlayState = 'running';
        banner.style.transform = '';
        banner.style.transition = '';
      });
      this.style.touchAction = '';
      return;
    }

    // Enable touch
    this.style.touchAction = 'pan-x';
    this.style.userSelect = 'none';
    this.style.webkitUserSelect = 'none';
    
    // Bind handlers
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
    
    // Add event listeners
    this.addEventListener('touchstart', this.handleTouchStart, { passive: false, capture: true });
    this.addEventListener('touchmove', this.handleTouchMove, { passive: false, capture: true });
    this.addEventListener('touchend', this.handleTouchEnd, { passive: false, capture: true });
    this.addEventListener('touchcancel', this.handleTouchEnd, { passive: false, capture: true });
    
    
    
    // Pause CSS animation completely
    const banners = this.querySelectorAll('.banner');
    banners.forEach(banner => {
      banner.style.animationPlayState = 'paused';
      banner.style.animation = 'none'; // Completely disable animation
    });
    
    // Initialize position
    this.updateDimensions();
    
    // Wait a moment for CSS animation to potentially start, then capture position
    setTimeout(() => {
      if (this.firstBanner) {
        const currentTransform = getComputedStyle(this.firstBanner).transform;
        if (currentTransform && currentTransform !== 'none') {
          const matrix = currentTransform.match(/matrix\(([^)]+)\)/);
          if (matrix) {
            const values = matrix[1].split(', ');
            this.scrollOffset = parseFloat(values[4]) || 0;
            
          }
        } else {
          this.scrollOffset = 0;
        }
        // Apply the transform immediately to take control
        this.applyTransform(this.scrollOffset);
       
      }
    }, 50);
    
    // Start auto-scroll
    setTimeout(() => {
      this.updateDimensions();
      if (this.bannerWidth > 0 && this.autoScrollSpeed !== 0) {
        this.startAutoScroll();
      }
    }, 200);
  }

  handleTouchStart(e) {
    if (!this.isMobile) return;
    
    const target = e.target;
    if (!this.contains(target) && target !== this) return;
    
    // Prevent multiple touch starts
    if (this.isDragging) {
      
      return;
    }
    
   
    
    this.touchActive = true;
    this.isDragging = true;
    this.swipeStarted = false;
    this.touchEndProcessed = false; // Reset flag for new touch
    
    if (e.touches && e.touches.length > 0) {
      this.startX = e.touches[0].clientX;
      this.currentX = this.startX;
      this.startY = e.touches[0].clientY;
    }
    
    // Cancel animation
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
    }
    
    // Get current offset from the actual transform
    if (this.firstBanner) {
      const currentTransform = getComputedStyle(this.firstBanner).transform;
      if (currentTransform && currentTransform !== 'none') {
        const matrix = currentTransform.match(/matrix\(([^)]+)\)/);
        if (matrix) {
          const values = matrix[1].split(', ');
          this.scrollOffset = parseFloat(values[4]) || 0;
        } else {
          this.scrollOffset = 0;
        }
      } else {
        this.scrollOffset = 0;
      }
    }
    
    
    
    e.preventDefault();
    e.stopPropagation();
  }

  handleTouchMove(e) {
    if (!this.isMobile || !this.isDragging) {
      
      return;
    }
    
    if (!e.touches || e.touches.length === 0) return;
    
    const currentX = e.touches[0].clientX;
    const currentY = e.touches[0].clientY;
    const deltaX = currentX - this.startX;
    const deltaY = currentY - this.startY;
    
    // Only allow swiping from right to left (negative deltaX)
    // Block left to right swiping (positive deltaX)
    if (deltaX > 0) {
      
      return;
    }
    
    // Check if horizontal swipe
    if (!this.swipeStarted) {
      const absDeltaX = Math.abs(deltaX);
      const absDeltaY = Math.abs(deltaY);
      
      if (absDeltaY > absDeltaX) {
       
        this.isDragging = false;
        return;
      }
      
      if (absDeltaX > 5) {
        
        this.swipeStarted = true;
        const links = this.querySelectorAll('a');
        links.forEach(link => {
          link.style.pointerEvents = 'none';
        });
      } else {
        return;
      }
    }
    
    this.currentX = currentX;
    const newOffset = this.scrollOffset + deltaX;
    
    
    
    this.applyTransform(newOffset);
    
    e.preventDefault();
    e.stopPropagation();
  }

  handleTouchEnd(e) {
    if (!this.isMobile) return;
    
    
    
    // Prevent double handling - use a flag to track if we've already processed
    if (this.touchEndProcessed) {
      
      return;
    }
    
    // Mark as processing
    this.touchEndProcessed = true;
    
    // Re-enable links
    const links = this.querySelectorAll('a');
    links.forEach(link => {
      link.style.pointerEvents = '';
    });
    
    const wasDragging = this.isDragging;
    const didSwipe = this.swipeStarted;
    
    this.isDragging = false;
    
    if (!didSwipe || !wasDragging) {
      
      this.touchActive = false;
      this.swipeStarted = false;
      this.touchEndProcessed = false;
      // Resume auto-scroll
      this.startAutoScroll();
      return;
    }
    
    const deltaX = this.currentX - this.startX;
    const finalOffset = this.scrollOffset + deltaX;
    const normalizedOffset = this.normalizeOffset(finalOffset);
    

    
    this.transitionToOffset(normalizedOffset, () => {
      this.touchActive = false;
      this.swipeStarted = false;
      this.touchEndProcessed = false;
      this.startAutoScroll();
    });
    
    e.preventDefault();
    e.stopPropagation();
  }

  normalizeOffset(offset) {
    if (!this.bannerWidth) return 0;
    
    let normalized = offset;
    
    // For right-to-left (normal, direction -1): negative values, wrap when <= -bannerWidth
    // For left-to-right (reverse, direction 1): positive values, wrap when >= bannerWidth
    if (this.animationDirection === -1) {
      // Right to left scrolling - negative values
      while (normalized <= -this.bannerWidth) {
        normalized += this.bannerWidth;
      }
    } else {
      // Left to right scrolling - positive values
      while (normalized >= this.bannerWidth) {
        normalized -= this.bannerWidth;
      }
    }
    
    return normalized;
  }

  applyTransform(offset) {
    const banners = this.querySelectorAll('.banner');
    banners.forEach((banner, index) => {
      // Apply transform to each banner - use !important to override any CSS
      banner.style.setProperty('transform', `translateX(${offset}px)`, 'important');
      banner.style.setProperty('transition', 'none', 'important');
      banner.style.setProperty('animation', 'none', 'important');
      banner.style.setProperty('will-change', 'transform', 'important');
    });
    
    // Force a reflow to ensure the transform is applied
    void this.offsetHeight;
  }

  transitionToOffset(offset, callback) {
    const banners = this.querySelectorAll('.banner');
    banners.forEach(banner => {
      banner.style.setProperty('transition', 'transform 0.3s ease-out', 'important');
      banner.style.setProperty('animation', 'none', 'important');
    });
    
    this.applyTransform(offset);
    this.scrollOffset = offset;
    
    setTimeout(() => {
      banners.forEach(banner => {
        banner.style.setProperty('transition', 'none', 'important');
      });
      if (callback) callback();
    }, 300);
  }

  startAutoScroll() {
    if (!this.isMobile || this.isDragging || this.touchActive) {
      
      return;
    }
    
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
    }
    
    this.updateDimensions();
    
    if (!this.bannerWidth || this.autoScrollSpeed === 0) {
      setTimeout(() => this.startAutoScroll(), 50);
      return;
    }
    
   
    const animate = () => {
      if (this.isDragging || this.touchActive || !this.isMobile) {
        this.animationFrame = null;
        return;
      }
      
      this.scrollOffset += this.autoScrollSpeed;
      this.scrollOffset = this.normalizeOffset(this.scrollOffset);
      this.applyTransform(this.scrollOffset);
      
      this.animationFrame = requestAnimationFrame(animate);
    };
    
    this.animationFrame = requestAnimationFrame(animate);
    
    // Log every second to verify it's running
    setTimeout(() => {
      if (this.animationFrame) {
        
      }
    }, 1000);
  }

  cleanup() {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
    }
    
    if (this.handleTouchStart) {
      this.removeEventListener('touchstart', this.handleTouchStart, { capture: true });
      this.removeEventListener('touchmove', this.handleTouchMove, { capture: true });
      this.removeEventListener('touchend', this.handleTouchEnd, { capture: true });
      this.removeEventListener('touchcancel', this.handleTouchEnd, { capture: true });
    }
  }

}

// Only define the custom element if it doesn't already exist
if (!customElements.get('scrolling-banner')) customElements.define('scrolling-banner', ScrollingBanner);

/******/ })()
;